/**
 * Create a debounced version of a function
 *
 * @param func
 * @param delay In milliseconds
 * @param isImmediate Should the function be fired immediately on first call?
 */
function debounce(func, waitMilliseconds, isImmediate) {
    if (waitMilliseconds === void 0) { waitMilliseconds = 50; }
    if (isImmediate === void 0) { isImmediate = false; }
    var timeoutId;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var doLater = function () {
            timeoutId = undefined;
            if (!isImmediate) {
                func.apply(context, args);
            }
        };
        var shouldCallNow = isImmediate && timeoutId === undefined;
        if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
        }
        timeoutId = window.setTimeout(doLater, waitMilliseconds);
        if (shouldCallNow) {
            func.apply(context, args);
        }
    };
}
export default debounce;
